export default __webpack_public_path__ + "static/media/genesys-img.f24b269d.svg";